"use client";

import { Badge } from "@/components/ui/badge";
import { CogIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { siteConfig } from "@/lib/siteConfig";

export default function FeaturesComponent() {
  return (
    <section
      className={"wrapper hero min-h-fit py-10"}
      style={{
        maskImage:
          "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)", // Added mask for fading edges
        WebkitMaskImage:
          "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)", // Added for Safari compatibility
      }}
    >
      <div className={"flex flex-col items-center text-center gap-y-10"}>
        <Badge>
          <CogIcon />
          Our Features & Capabilities
        </Badge>
        <h1
          className={
            "text-5xl font-bold bg-gradient-to-r from-primary via-primary/90 to-emerald-400 bg-clip-text text-transparent"
          }
        >
          Comprehensive
          <br /> Solutions
        </h1>
        <p className={"text-muted-foreground text-xl font-semibold"}>
          Discover our extensive range of technology solutions across seven{" "}
          <br /> key sectors, backed by global partnerships and local expertise.
        </p>
        <Button>Explore Solutions</Button>

        <div className={"grid grid-cols-2 md:grid-cols-4 gap-4"}>
          {siteConfig.featureStats.map((stat, index) => (
            <div key={index} className={"flex flex-col items-center gap-2"}>
              <span className={"text-primary bg-primary/10 p-5 rounded"}>
                <stat.icon />
              </span>
              <h1 className={"text-3xl font-bold"}>{stat.number}</h1>
              <p className={"text-sm text-muted-foreground"}>{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
